import { render } from "./uz.vue?vue&type=template&id=7f9e4aa2&scoped=true&ts=true"
import script from "./uz.vue?vue&type=script&lang=ts"
export * from "./uz.vue?vue&type=script&lang=ts"

import "./uz.vue?vue&type=style&index=0&id=7f9e4aa2&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9e4aa2"]])

export default __exports__